import { getCaptchaResponse, resetCaptcha } from "./RecaptchaManager";
import { Notification } from "./UI/Notification";
export class FeedbackManager {
    constructor(authenticated = false) {
        this.authenticated = authenticated;
    }
    Init() {
        $("form[data-feedbackkey]").each((idx, el) => {
            this.SetupEvents($(el));
        });
    }
    SetFeedbackCallback(callback) {
        this.feedbackCallback = callback;
    }
    SetupEvents(formContainer) {
        const feedbackTypeKey = formContainer.data("feedbackkey");
        formContainer.on("click", "input[type=submit]", (ev) => {
            ev.stopImmediatePropagation();
            ev.preventDefault();
            this.SubmitFeedback(formContainer, feedbackTypeKey);
        });
        formContainer.on("click", "input[type=reset]", (ev) => {
            ev.preventDefault();
            if ($(ev.target).attr("id").match(feedbackTypeKey + "$")) {
                this.Reset(formContainer);
            }
        });
    }
    Reset($targetForm) {
        if ($targetForm.length > 0) {
            $targetForm.get()[0].reset();
            $targetForm.validate().resetForm();
            this.ResetRecaptcha($targetForm);
            this.SubmitResetLabels($targetForm);
        }
    }
    SubmitResetLabels($targetform) {
        const $targetSubmitLabel = $("#feedback-submit-label");
        if ($targetSubmitLabel.length) {
            const $submitButton = $("#submit_" + $targetform.attr("id"));
            $targetSubmitLabel.attr("for", $submitButton.attr("id"));
            const $targetCancelLabel = $("#feedback-reset-label");
            const $cancelButton = $("#reset_" + $targetform.attr("id"));
            $targetCancelLabel.attr("for", $cancelButton.attr("id"));
            $targetform.find(".form__controls").hide();
            $targetform.find(".feedback__error").hide();
            $targetform.find("input").first().trigger("focus");
        }
    }
    SubmitFeedback($form, feedbackTypeKey) {
        const $target = $form.find("input[type=submit]");
        const $progress = $form.find(".progress");
        const $fileUpload = $form.find(".has-file");
        $form.validate();
        if (!$form.valid()) {
            return;
        }
        if ($form.find("label.has-error").length > 0) {
            this.Notify("Your form contains invalid/big file. Please replace or reset the form", true);
            return;
        }
        const formElement = $form.get()[0];
        const formData = new FormData(formElement);
        if (!this.authenticated) {
            const recaptchaWidgetId = parseInt($form.find("div.g-recaptcha").attr("data-RecaptchaWidgetId"));
            const captchaResponse = getCaptchaResponse(recaptchaWidgetId);
            if (captchaResponse.length === 0) {
                this.Notify("Please fill in the recaptcha.", true);
                return;
            }
            formData.append("captchaResponse", captchaResponse);
        }
        let submittedFromUrl = $("link[itemprop='mainEntityOfPage']").attr("href");
        if (!submittedFromUrl) {
            submittedFromUrl = $("link[rel='canonical']").attr("href");
        }
        let submittedFromTitle = $("h1[itemprop='headline']").text();
        if (!submittedFromTitle) {
            submittedFromTitle = $("meta[itemprop='name']").attr("content");
        }
        formData.append("feedbackTypeKey", feedbackTypeKey);
        formData.append("submittedFromUrl", submittedFromUrl);
        formData.append("submittedFromTitle", submittedFromTitle);
        $form.addClass("u-loading");
        $target.addClass("submitting");
        $.ajax({
            url: "/feedback/create",
            type: "POST",
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            xhr: () => {
                var myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload && $fileUpload.length) {
                    myXhr.upload.addEventListener('progress', (e) => {
                        if (e.lengthComputable) {
                            var p = e.loaded / e.total * 100;
                            this.OnFileUploadProgress(p, $progress);
                        }
                    }, false);
                }
                return myXhr;
            }
        }).done((data) => {
            $form.removeClass("u-loading");
            $target.removeClass("submitting");
            if (data.Success) {
                this.Notify(data.Message, false);
                setTimeout(() => {
                    this.Reset($form);
                    $form.removeClass("u-hidden");
                    $target.removeClass("submitting");
                    Notification.RemoveNotyElements();
                }, 2000);
                $progress.addClass("u-hidden");
            }
            else {
                this.Notify(data.Message, true);
            }
            if (this.feedbackCallback) {
                this.feedbackCallback(true, data.Message, feedbackTypeKey, {
                    url: window.location.href,
                    title: document.title
                });
            }
        }).fail(() => {
            $form.removeClass("u-loading");
            $target.removeClass("submitting");
            this.Notify("An error occurred while trying to submit feedback", true);
            $progress.addClass("u-hidden");
            if (this.feedbackCallback) {
                this.feedbackCallback(false, "An error occurred while trying to submit feedback", feedbackTypeKey, {
                    url: window.location.href,
                    title: document.title
                });
            }
        });
    }
    OnFileUploadProgress(progress, $progress) {
        const $progressBar = $(".file__progress");
        $progress.removeClass("u-hidden");
        if ($progressBar.length > 0) {
            let uploadMessage = progress < 100 ? "Uploading..." : "Upload completed successfully";
            $(".upload--progress .message").html(uploadMessage);
            $progressBar.val(progress);
            $progressBar.html(progress + "%");
            $progressBar.attr('aria-valuenow', progress);
        }
    }
    ResetRecaptcha(formContainer) {
        try {
            if (!window.grecaptcha) {
                return;
            }
            const recaptchaWidgetId = parseInt(formContainer.find("div.g-recaptcha").attr("data-RecaptchaWidgetId"));
            resetCaptcha(recaptchaWidgetId);
        }
        catch (e) {
            console.log(e);
        }
    }
    Notify(message, error) {
        if (error) {
            Notification.Notify(message, "error", "bottomRight");
        }
        else {
            Notification.Notify(message, "success", "bottomRight");
        }
    }
}
//# sourceMappingURL=FeedbackManager.js.map